import { Theme } from '@mui/material/styles'

export default function Chip(_: Theme) {
  return {
    MuiChip: {},
  }
}
